<template>
  <div class="pay">
    <div class="pay-title">
      请选择支付方式
    </div>
    <div class="pay-wrapper">
      <div v-for="(item, index) in pays" :key="`pay${index}`" @click="choose(item.type)">
        <div class="pay-item" v-if="payConfig.includes(item.type.toString())">
            <img class="check" v-if="active===item.type" src="../../views/tickets/static/checked.png" alt="">
            <img class="check" v-else src="../../views/tickets/static/unchecked.png" alt="">
            <img class="pay-icon" :src="item.imgurl" alt="">
            <p>{{item.text}}</p>
            <div v-if="item.tip" class="tip">
                <p v-for="(it, index) in item.tips" :key="`tip${index}`">{{it}}</p>
            </div>
        </div>
       
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/utils/http'
export default {
  data () {
    return {
      pays:[
        {imgurl: require('./static/wx.png'), type: 2, text: '微信支付', tip: ''},
        {imgurl: require('./static/zfb.png'), type: 1, text: '支付宝支付', tip: ''},
        {imgurl: require('./static/qb.png'), type: 4, text: '现场支付', tip: '请于8月5-6日在南京国际青年会议中心大厅进行参会签到并缴纳会务费，支持现金、微信、支付宝。'},
        {imgurl: require('./static/zz.png'), type: 3, text: '转账汇款', tip: ''},
      ],
      active: '2',
      payConfig: ['2','4'],
      onSitePayDesc: '',
      transferPayDesc: ''
    }
  },
  props: ['isFrom'],
  watch: {
    active: {
      immediate: true,
      deep: true,
      handler(_val) {
        this.$emit('click', _val)
      }
    }
  },
  computed: {
      meetingId() {
            return this.$store.state.meetingId || localStorage.getItem('meetingId')
      },
  },
  methods: {
    choose(type) {
      this.active = type
      this.$emit('getPayStatus', type)
    },
    async getPayConfig() {
        let url = '/renren-fast/app/audience/payConfigInfo'
        if(this.isFrom === 'hotel'){
          url = '/renren-fast/app/audience/payHotelConfigInfo'
        }
        const res = await http.get(`${url}/${this.meetingId}`)
        console.log(res)
        if(this.isFrom){
          if(res.code ===0 && res.meetingHotelPayConfig){
            this.payConfig = res.meetingHotelPayConfig.payConfig.split('-')
            this.onSitePayDesc = res.meetingHotelPayConfig.onSitePayDesc
            this.transferPayDesc = res.meetingHotelPayConfig.transferPayDesc
          }
        }
        if(res.code ===0 && res.meetingPayConfig){
            this.payConfig = res.meetingPayConfig.payConfig.split('-')
            this.onSitePayDesc = res.meetingPayConfig.onSitePayDesc
            this.transferPayDesc = res.meetingPayConfig.transferPayDesc
        }
        this.pays[2].tip = this.onSitePayDesc
        this.pays[2].tips = this.onSitePayDesc.split('-')
        this.pays[3].tip = this.transferPayDesc
        this.pays[3].tips = this.transferPayDesc.split('-')

    }
  },
  created() {
      this.getPayConfig()
  }
}
</script>
<style lang="stylus" scoped>
  .pay
      padding 21px 22px
      background #ffffff
      .pay-title
          color #000
          font-size 32px
          margin-bottom 22px
      .pay-wrapper
          border 1px solid rgba(172,172,172,1)
          border-bottom 0px solid #fff
          .pay-item
              padding-left 21px
              display flex
              align-items center
              flex-wrap wrap
              min-height 78px
              border-bottom:1px solid rgba(172,172,172,1)
              padding-top 10px
              padding-bottom 10px
              .check
                  width 28px
                  height 28px
              .pay-icon
                  width 60px
                  padding 0 18px
              p
                  font-size 28px
              .tip
                  font-size 24px
                  width 623px
                  padding-left 39px
                  padding-right 27px
                  margin-top 10px
       @media screen and (min-width: 800px)
          .pay-title
            color #000
            font-size 20px
            margin-bottom 15px
          .pay-wrapper
            .pay-item
              padding-left 20px
              display flex
              align-items center
              flex-wrap wrap
              min-height 40px
              border-bottom:1px solid rgba(172,172,172,1)
              padding-top 5px
              padding-bottom 5px
              .check
                  width 15px
                  height 15px
              .pay-icon
                  width 30px
                  padding 0 18px
              p
                  font-size 20px
              .tip
                  font-size 20px
                  width 623px
                  padding-left 39px
                  padding-right 27px
                  margin-top 10px

</style>

